// TODO: Document this interface. What does each property means?
export interface TypeHelpOptions {
  newObject: any;
  object: Record<string, any>;
  property: string;
}
